import type { CityConfig } from "../city-template/types";

export const kentwoodConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Kent County Clerk", href: "https://www.accesskent.com/clerk", description: "Kent County Clerk — marriage license issuance" },
    { label: "Divorce Records — Kent County Clerk", href: "https://www.accesskent.com/clerk", description: "Kent County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Kentwood",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "kentwood",
  route: "/cities/kentwood",
  title: "Emergency Passport Kentwood, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Kentwood, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Kentwood, Caledonia, Cutlerville, and all Kent County residents. Southeast Grand Rapids metro coverage. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Kentwood, MI",
  heroSubtitle: "Kentwood travelers — Kent County residents, Woodland Mall shoppers, 44th Street corridor workers, and southeast Grand Rapids metro families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Kent County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20suburban%20Michigan%20retail%20corridor%20with%20modern%20shopping%20centers%2C%20tree-lined%20parking%20lots%2C%20wide%20commercial%20boulevard%2C%20green%20lawns%2C%20summer%20afternoon%20light%2C%20clear%20sky%2C%20suburban%20prosperity%2C%20no%20text%20no%20people%2C%20clean%20architectural%20landscape%20photography&width=1800&height=700&seq=kentwood-hero-001&orientation=landscape",
  heroImageAlt: "Suburban Kentwood Michigan retail corridor with modern shopping centers and tree-lined commercial boulevard",
  geoPosition: "42.8695;-85.6447",
  geoPlacename: "Kentwood, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 155 miles east of Kentwood — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Kentwood", zips: "49508, 49512, 49546, 49518" },
    { name: "Grand Rapids", zips: "49501, 49503, 49504, 49505, 49506, 49507, 49508, 49509, 49512, 49525, 49534, 49544" },
    { name: "Wyoming", zips: "49509, 49519" },
    { name: "Caledonia", zips: "49316" },
    { name: "Cutlerville", zips: "49508, 49548" },
    { name: "Byron Center", zips: "49315" },
    { name: "East Grand Rapids", zips: "49506" },
    { name: "Grandville", zips: "49418" },
    { name: "Jenison", zips: "49428" },
    { name: "Hudsonville", zips: "49426" },
    { name: "Walker", zips: "49534, 49544" },
    { name: "Holland", zips: "49422, 49423, 49424" },
    { name: "Ada", zips: "49301" },
    { name: "Cascade", zips: "49546" },
    { name: "Comstock Park", zips: "49321" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Kent County Expertise", desc: "Southeast Grand Rapids metro, Gerald R. Ford International Airport, and West Michigan travel support" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in Kent County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Grand Rapids, MI", route: "/grand-rapids" },
    { name: "Emergency passport services in Wyoming, MI", route: "/states/wyoming" },
    { name: "Urgent passport services in Holland, MI", route: "/cities/holland" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Kentwood, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 155-mile drive or appointment wait. Kentwood residents can ship from any UPS or FedEx in Kent County.",
  fpcOfficeDistance: "Serving Kentwood, Caledonia, Cutlerville, East Grand Rapids, Grand Rapids, Wyoming, and all of Kent County and the Grand Rapids metro area",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Kentwood and the greater Kent County region. From the 44th Street corridor to Woodland Mall, from Caledonia to East Grand Rapids — we serve all of southeast Grand Rapids metro. The Detroit Passport Agency is approximately 155 miles east, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Kentwood and all Kent County communities including Caledonia, Cutlerville, East Grand Rapids, Grand Rapids, Wyoming, Grandville, Jenison, Hudsonville, Walker, and Comstock Park. We also serve West Michigan travelers and Gerald R. Ford International Airport flyers.",
  howItWorksIntro: "Most Kentwood travelers complete everything online and ship documents overnight. No driving 155 miles to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Kentwood is a thriving Kent County community with strong ties to Grand Rapids, the Woodland Mall retail corridor, and the 44th Street business district. Here are the most common passport mistakes we see from southeast Grand Rapids metro travelers.",
  testimonialsIntro: "Kentwood travelers — from Gerald R. Ford International Airport flyers to Woodland Mall professionals to East Kentwood families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Kentwood, MI? Here are the most common ones we hear from Kent County and Grand Rapids metro travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for GRR Airport and Kent County travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in Detroit — 155-mile drive", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Kentwood travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute Gerald R. Ford International Airport flights, family emergencies, and business travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "GRR Airport and Kent County travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Kentwood adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Kent County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Kentwood residents and families — including new citizens, college students, and Kent County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Kentwood residents who lost their passport before international travel or GRR Airport departure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Kentwood-area families planning international vacations, study abroad, or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Kentwood and Kent County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Kentwood MI", description: "Urgent passport processing for Kentwood Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Kentwood MI", description: "Fast passport renewal for Kentwood Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Kentwood MI", description: "New passport application services for Kentwood Michigan residents applying for their first passport." },
    { name: "Child Passport Kentwood MI", description: "Minor passport services for Kentwood Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Kentwood, MI",
      rating: 5,
      text: "Cruise to the Bahamas in 4 days and my passport was expired. Fast Passport Center saved it — renewed in 2 days. I shipped from the UPS Store near Woodland Mall and had it back before my flight. Amazing service for Kentwood.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "David H.",
      location: "Caledonia, MI",
      rating: 5,
      text: "Business trip to London in 6 days and my passport was lost. Fast Passport Center had a replacement in our hands in 48 hours. Their courier service is a game changer for southeast Grand Rapids metro.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Amanda K.",
      location: "Kentwood, MI",
      rating: 5,
      text: "First-time passport for a family trip to Japan with 9 days notice. Fast Passport Center processed all five passports in 6 days. They caught a mistake on one of our forms that would have delayed us.",
      service: "First-Time Passport",
    },
    {
      name: "Robert P.",
      location: "East Grand Rapids, MI",
      rating: 5,
      text: "Family vacation to Italy and I realized my passport was expiring too soon. Fast Passport Center got me renewed in 3 days. Professional, fast, and they answered all my questions about the Schengen requirements.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "kent-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 155 miles east of Kentwood — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "kent-2",
      name: "Kentwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3660 29th St SE",
      city: "Kentwood",
      state: "MI",
      zip: "49512",
      phone: "(616) 949-9610",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Kentwood — near the 44th Street corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Kentwood acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Woodland Mall and southeast Grand Rapids metro residents.",
      icon: "ri-mail-line",
    },
    {
      id: "kent-3",
      name: "Grand Rapids Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "600 Fountain St SE",
      city: "Grand Rapids",
      state: "MI",
      zip: "49503",
      phone: "(616) 458-3351",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Grand Rapids — approximately 5 miles northwest of Kentwood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Grand Rapids and western Kentwood residents. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "kent-4",
      name: "Caledonia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9241 Cherry Valley Ave SE",
      city: "Caledonia",
      state: "MI",
      zip: "49316",
      phone: "(616) 891-2161",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Caledonia — approximately 8 miles south of Kentwood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Caledonia and southern Kentwood residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "kent-5",
      name: "Wyoming Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1850 28th St SW",
      city: "Wyoming",
      state: "MI",
      zip: "49519",
      phone: "(616) 538-5320",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Wyoming — approximately 6 miles west of Kentwood",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wyoming and western Kentwood residents. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Kent County" },
    { feature: "GRR Airport & Kent County Expertise", agency: "No tailored advice", fpc: "Yes — Gerald R. Ford International Airport and Kent County travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Kentwood and Kent County travelers often discover passport issues right before GRR Airport departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for International Air Travel",
      description: "Some southeast Grand Rapids metro travelers assume a passport card is sufficient for all travel — but passport cards are only valid for land and sea border crossings. All international flights require a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Kent County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Gerald R. Ford International Airport Flight Requirements",
      description: "Gerald R. Ford International Airport (GRR) in Grand Rapids has growing international flight options. Many Kentwood travelers also use Chicago O'Hare or Detroit Metro. Verify passport requirements for all connecting airports.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Kent County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Kentwood, Grand Rapids, or Wyoming." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no 155-mile drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Kent County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Kentwood, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Kentwood, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 155 miles east. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the long drive and wait." },
    { q: "How fast can I get an emergency passport in Kentwood?", a: "Fast Passport Center offers emergency passport processing in Kentwood, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 155 miles east or take a day off work." },
    { q: "Do I need a passport for international flights from Gerald R. Ford International Airport?", a: "Yes. All international flights from Gerald R. Ford International Airport (GRR) in Grand Rapids require a passport book. GRR serves Kentwood and all of Kent County. While GRR has growing international options, many Kentwood travelers also connect through Chicago O'Hare or Detroit Metro for international flights. A passport book is required for all international air travel regardless of your departure airport." },
    { q: "Can I get an expedited passport in the Kentwood suburbs like Caledonia or Cutlerville?", a: "Absolutely. Fast Passport Center serves all of Kent County including Caledonia, Cutlerville, East Grand Rapids, Wyoming, Grandville, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Kentwood-area travelers use for international flights?", a: "Gerald R. Ford International Airport (GRR) in Grand Rapids is the primary airport for Kentwood and Kent County — approximately 5–10 miles northwest. GRR has growing domestic and international service. Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international hub — approximately 155 miles east. Many Kentwood travelers also use Chicago O'Hare (ORD) for international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Kentwood, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Kentwood-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Kentwood, Grand Rapids, and Wyoming offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula from Kentwood?", a: "Yes. Fast Passport Center serves all of Michigan including the Upper Peninsula. Our courier service is especially valuable for remote UP communities, which would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Kentwood", address: "4055 28th St SE, Kentwood, MI 49512", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS Pharmacy — Kentwood", address: "4255 Kalamazoo Ave SE, Kentwood, MI 49508", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Kentwood", address: "5125 28th St SE, Kentwood, MI 49512", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — Grand Rapids", address: "2025 E Beltline Ave NE, Grand Rapids, MI 49525", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Kentwood", address: "5125 28th St SE, Kentwood, MI 49512", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Kentwood, Caledonia, and southeast Kent County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Grand Rapids", address: "3777 3 Mile Rd NW, Grand Rapids, MI 49544", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Grand Rapids, Walker, and northern Kent County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "GRR",
      name: "Gerald R. Ford International Airport",
      distance: "Located in Grand Rapids — approximately 5–10 miles northwest of Kentwood",
      address: "5500 44th St SE, Grand Rapids, MI 49512",
      note: "Primary airport for Kentwood and Kent County. Growing domestic and international service. Southwest, Delta, American, United, and Allegiant service. International flights to Cancun and Toronto available seasonally. Most Kentwood international travelers connect through DTW or Chicago O'Hare.",
      flightUrl: "https://www.grr.org/",
      flightLabel: "GRR Airport Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 155 miles east of Kentwood via I-96",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for West Michigan. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan. Most Kentwood international travelers connect through DTW.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
  ],
};